import type { ButtonConfig } from '../../declare'
import { useState, useContext } from 'react'
import { toJS } from 'mobx'
import { Button } from 'antd'
import { EasyIcon, ListPropsContext, postMsg } from 'src/components'
import { listStore } from 'src/stores'
import { $api } from 'src/plugins'

type Props = {
  config: ButtonConfig
}

const SaveBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const [loading, setLoading] = useState(false)
  const handleSave = () => {
    const { API_URL } = props.config
    if (!API_URL) {
      postMsg('未配置保存接口', 'error')
      return
    }
    setLoading(true)
    const copyData = toJS(table.tableData.dataSource)
    $api['app/getDataByPost'](
      { Data: copyData },
      { url: API_URL }
    ).then((res: any) => {
      if (res) {
        postMsg('操作成功')
        table?.reload()
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const { LABEL, ICON } = props.config
  return (
    <Button
      type='primary'
      icon={<EasyIcon type={ICON} defaultIcon='SaveOutlined' />}
      loading={loading}
      onClick={handleSave}
    >{LABEL}</Button>
  )
}

export default SaveBtn